// extracted by mini-css-extract-plugin
export default {"teamRoleSelector":"BiohWYlKPzEf7HffIpb5"};